import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ADVANCED_SEARCH_SETTINGS_DEFAULTS } from '../../../../interfaces/advancedSearch.interface';

@Component({
    selector: 'app-advanced-search-toggle',
    templateUrl: './advanced-search-toggle.component.html',
    styleUrls: ['./advanced-search-toggle.component.scss']
})
export class AdvancedSearchToggleComponent implements OnInit {

    @Input() control: FormControl;
    @Input() label: string;

    readonly DEFAULTS = ADVANCED_SEARCH_SETTINGS_DEFAULTS;

    constructor() { }

    ngOnInit(): void { }
}
